<template>
  <div >
    <div style="float:left;" v-if="totalElements > 0">
      <nav aria-label="Page navigation example">
        <ul class="pagination pagination-sm pagination-torre">
          <li class="page-item disabled" >
            <a class="page-link" href="#" tabindex="-1">
              Liczba elementów: {{ totalElements }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <div class="container" v-if="showPagination">
      <div class="row align-items-center justify-content-center">
        <div class="col-auto">

          <nav aria-label="Page navigation example">
            <ul class="pagination pagination-sm pagination-torre">
              <li class="page-item" @click.prevent="onPrevClicked()" v-if="showPrev">
                <a class="page-link" href="#" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                  <span class="sr-only">Previous</span>
                </a>
              </li>
              <li class="page-item disabled" >
                <a class="page-link" href="#" tabindex="-1">Strona {{ currentPage }} z {{ totalPages }}</a>
              </li>
              <li class="page-item" @click.prevent="onNextClicked()" v-if="showNext">
                <a class="page-link" href="#" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                  <span class="sr-only">Next</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MainPagination",
  data: () => ({
    data: {},
    totalPages: 0,
    currentPage: -1,
    isFirst: false,
    isLast: false
  }),
  created: function() {
    this.$parent.$on('filterChanged', this.onFilterChanged);
  },
  computed: {
    totalElements: function() {
      return this.data.totalElements || 0
    },
    showNext: function() {
      return !this.isLast;
    },
    showPrev: function() {
      return !this.isFirst;
    },
    showPagination: function() {
      return this.totalPages > 1;
    }
  },
  methods: {
    onPrevClicked: function () {
      var pageToSend = this.currentPage - 1 - 1;
      this.emitPageVent(pageToSend);
    },
    onNextClicked: function() {
      var pageToSend = this.currentPage + 1 - 1;
      this.emitPageVent(pageToSend);
    },
    onFilterChanged(payload) {
      this.data = payload.data;
      this.assignLinksInfo();
    },
    emitPageVent: function(pageToSend) {
      this.$eventHub.$emit("paginationClicked", {
        pageToSend: pageToSend
      });
    },
    assignLinksInfo: function() {
      this.currentPage = this.data.pageable.pageNumber + 1;
      this.isFirst = this.data.first;
      this.isLast = this.data.last;
      this.totalPages = this.data.totalPages;
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pagination/MainPagination.vue